import { defineMessages } from 'react-intl';
export default defineMessages({
    april: {
        id: 'calendar.april',
        defaultMessage: 'April',
    },
    august: {
        id: 'calendar.august',
        defaultMessage: 'August',
    },
    dateFormat: {
        id: 'calendar.dateFormat',
        defaultMessage: 'Date format',
    },
    day: {
        id: 'calendar.day',
        defaultMessage: 'Day',
    },
    december: {
        id: 'calendar.december',
        defaultMessage: 'December',
    },
    end: {
        id: 'calendar.end',
        defaultMessage: 'End',
    },
    february: {
        id: 'calendar.february',
        defaultMessage: 'February',
    },
    hours: {
        id: 'calendar.hours',
        defaultMessage: 'Hours',
    },
    hoursShort: {
        id: 'calendar.hoursShort',
        defaultMessage: 'hrs',
    },
    january: {
        id: 'calendar.january',
        defaultMessage: 'January',
    },
    july: {
        id: 'calendar.july',
        defaultMessage: 'July',
    },
    june: {
        id: 'calendar.june',
        defaultMessage: 'June',
    },
    last24Hours: {
        id: 'calendar.last24Hours',
        defaultMessage: 'Last 24 hours',
    },
    last30Days: {
        id: 'calendar.last30Days',
        defaultMessage: 'Last 30 days',
    },
    last7Days: {
        id: 'calendar.last7Days',
        defaultMessage: 'Last 7 days',
    },
    march: {
        id: 'calendar.march',
        defaultMessage: 'March',
    },
    max: {
        id: 'calendar.max',
        defaultMessage: 'Max',
    },
    may: {
        id: 'calendar.may',
        defaultMessage: 'May',
    },
    month: {
        id: 'calendar.month',
        defaultMessage: 'Month',
    },
    months: {
        id: 'calendar.months',
        defaultMessage: 'months',
    },
    november: {
        id: 'calendar.november',
        defaultMessage: 'November',
    },
    october: {
        id: 'calendar.october',
        defaultMessage: 'October',
    },
    oneDay: {
        id: 'calendar.oneDay',
        defaultMessage: '1-day',
    },
    oneHour: {
        id: 'calendar.oneHour',
        defaultMessage: '1-hour',
    },
    oneMonth: {
        id: 'calendar.oneMonth',
        defaultMessage: '1-month',
    },
    oneWeek: {
        id: 'calendar.oneWeek',
        defaultMessage: '1-week',
    },
    previous24Hours: {
        id: 'calendar.previous24Hours',
        defaultMessage: 'Previous 24 hours',
    },
    previous30Days: {
        id: 'calendar.previous30Days',
        defaultMessage: 'Previous 30 days',
    },
    previous7Days: {
        id: 'calendar.previous7Days',
        defaultMessage: 'Previous 7 days',
    },
    previousDay: {
        id: 'calendar.previousDay',
        defaultMessage: 'Previous day',
    },
    previousMonth: {
        id: 'calendar.previousMonth',
        defaultMessage: 'Previous month',
    },
    previousWeek: {
        id: 'calendar.previousWeek',
        defaultMessage: 'Previous week',
    },
    previousYear: {
        id: 'calendar.previousYear',
        defaultMessage: 'Previous year',
    },
    sameDayLastYear: {
        id: 'calendar.sameDayLastYear',
        defaultMessage: 'Same day last year',
    },
    sameMonthLastYear: {
        id: 'calendar.sameMonthLastYear',
        defaultMessage: 'Same month last year',
    },
    selectADate: {
        id: 'calendar.selectADate',
        defaultMessage: 'Select a date',
    },
    selectAMonth: {
        id: 'calendar.selectAMonth',
        defaultMessage: 'Select a month',
    },
    selectAYear: {
        id: 'calendar.selectAYear',
        defaultMessage: 'Select a year',
    },
    selectGranularity: {
        id: 'calendar.selectGranularity',
        defaultMessage: 'Select a granularity',
    },
    selectAggregation: {
        id: 'calendar.selectAggregation',
        defaultMessage: 'Select displayed value',
    },
    selectTimescale: {
        id: 'calendar.selectTimescale',
        defaultMessage: 'Select a time scale',
    },
    september: {
        id: 'calendar.september',
        defaultMessage: 'September',
    },
    sixHours: {
        id: 'calendar.sixHours',
        defaultMessage: '6-hour',
    },
    start: {
        id: 'calendar.start',
        defaultMessage: 'Start',
    },
    thirtyMinutes: {
        id: 'calendar.thirtyMinutes',
        defaultMessage: '30-min',
    },
    threeHours: {
        id: 'calendar.threeHours',
        defaultMessage: '3-hour',
    },
    use24HourFormat: {
        id: 'calendar.use24HourFormat',
        defaultMessage: 'Use 24-hour format',
    },
    week: {
        id: 'calendar.week',
        defaultMessage: 'Week',
    },
    year: {
        id: 'calendar.year',
        defaultMessage: 'Year',
    },
    yesterday: {
        id: 'calendar.yesterday',
        defaultMessage: 'Yesterday',
    },
});
